// removed by extract-text-webpack-plugin
module.exports = {"page":"_31FuVxcXTKCZSas1ezXbd5","sidebar":"MPb0JW6s3TKL0D_1YEJmf","status-wrapper":"ez1otQEXBazD-iqQewvdt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailContainer.less
 ** module id = 849
 ** module chunks = 0
 **/